import { BrowserAndTabletView } from 'components/DeviceDetect'
import React from 'react'
import {
  ProductGalleryDesktop,
  ProductGallery,
  ProductImageSlider,
  ProductPictureSmall,
} from './ProductImages.style'
import Slider, { Slide } from 'components/Slider'
import useProduct from 'store/SingleProductProvider'
import ImageMagnifier from './ImageMagnifier'

const useProcessedMedia = (images, video_links) => {
  const safeVideoLinks = Array.isArray(video_links)
    ? video_links
    : video_links
    ? [video_links]
    : []

  const processedVideoLinks = safeVideoLinks.map(html => {
    const htmlStr = html.toString()
    let updated = htmlStr

    if (htmlStr.includes('iframe')) {
      updated = htmlStr.replace(
        /src=(['"])(.*?)\1/i,
        (match, quote, srcUrl) => {
          if (srcUrl.includes('?')) {
            if (!srcUrl.includes('autoplay=1')) {
              return `src=${quote}${srcUrl}&autoplay=1&mute=1${quote}`
            }
            return match
          } else {
            return `src=${quote}${srcUrl}?autoplay=1&mute=1${quote}`
          }
        }
      )

      if (!updated.includes('allow="autoplay"')) {
        updated = updated.replace(/width="[^"]*"/g, '')
        updated = updated.replace(
          '<iframe',
          '<iframe class="responsive-video-iframe" style="width:100%; aspect-ratio:16/9;"'
        )
      }
    }

    return updated
  })

  return [...images, ...processedVideoLinks]
}

const ImagesSlider = ({ images, video_links, isDesktop }) => {
  const mergedData = useProcessedMedia(images, video_links)

  const sliderProps = isDesktop
    ? {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: true,
        customPaging: i => {
          const item = mergedData[i]
          let thumbnail = ''

          if (typeof item === 'string' && item.includes('youtube.com')) {
            const match = item.match(/youtube\.com\/embed\/([^"?]+)/)
            if (match && match[1]) {
              const videoId = match[1]
              thumbnail = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
            }
          } else {
            thumbnail = item
          }

          return (
            <a href="##">
              <ProductPictureSmall src={thumbnail || ''} />
            </a>
          )
        },
        dotsClass: 'slick-dots slick-thumb',
        arrows: false,
      }
    : {}

  if (!Array.isArray(images)) return 'not images'

  const isVideo = media =>
    typeof media === 'string' &&
    (media.endsWith('.mp4') ||
      media.includes('iframe') ||
      media.includes('youtube') ||
      media.includes('vimeo'))

  if (isDesktop) {
    return (
      <ProductImageSlider {...sliderProps}>
        {mergedData.map((media, key) => (
          <div className="product-image" key={key}>
            {isVideo(media) ? (
              <div dangerouslySetInnerHTML={{ __html: media || '' }} />
            ) : (
              <ImageMagnifier imageUrl={media} zoom={4} />
            )}
          </div>
        ))}
      </ProductImageSlider>
    )
  }

  return (
    <Slider>
      {mergedData.map((media, key) => (
        <Slide key={key}>
          {isVideo(media) ? (
            <div dangerouslySetInnerHTML={{ __html: media || '' }} />
          ) : (
            <img itemProp="image" className="product-image" src={media} />
          )}
        </Slide>
      ))}
    </Slider>
  )
}

export function DesktopProductImages() {
  const {
    product: { video_links },
    images,
  } = useProduct()

  return (
    <BrowserAndTabletView>
      <ProductGalleryDesktop>
        <ImagesSlider
          images={images}
          video_links={video_links}
          isDesktop={true}
        />
      </ProductGalleryDesktop>
    </BrowserAndTabletView>
  )
}

export function MobileProductImages() {
  const {
    product: { video_links },
    images,
  } = useProduct()

  return (
    <ProductGallery>
      <ImagesSlider
        images={images}
        video_links={video_links}
        isDesktop={false}
      />
    </ProductGallery>
  )
}
